// src/redux/aboutAppSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  records: [],
  isLoading: false,
  error: null,
};

const aboutAppSlice = createSlice({
  name: "aboutApp",
  initialState,
  reducers: {
    setAboutAppLoading: (state, action) => {
      state.isLoading = action.payload;
      state.error = null;
    },
    setAboutAppError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setAboutAppRecords: (state, action) => {
      state.records = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    deleteAboutAppRecord: (state, action) => {
      state.records = state.records.filter((r) => r._id !== action.payload);
    },
  },
});

export const {
  setAboutAppLoading,
  setAboutAppError,
  setAboutAppRecords,
  deleteAboutAppRecord,
} = aboutAppSlice.actions;

export default aboutAppSlice.reducer;
